<template>
    <div class="app_view">
        <van-nav-bar
            :title="language.feedback_details"
            @click-left="onClickLeft"
            fixed
            placeholder
        >
            <span class="head_record" slot="left">
                <van-icon name="arrow-left" size="20px" color="#323233"/>
            </span>
        </van-nav-bar>
        <div class="content bgcolor">
            <template v-if="failsbtn">
                <failed_load></failed_load>
            </template>
            <template v-if="hasData">
                <div class="record_view">
                    <div class="record_time">
                        <span>{{data.createTime}}</span>
                        <span :class="[+data.replyContentList.length?'replied':'Awaiting_reply']">{{+data.replyContentList.length?language.replied:language.Awaiting_reply}}</span>
                    </div>
                    <div class="record_text">
                        {{data.content}}
                    </div>
                    <div class="record_img" v-if="+data.imgList.length">
                            <van-image
                                v-for="(imgsrc,imgindex) in data.imgList"
                                :key="imgindex+'01'"
                                width="32%"
                                height="32%"
                                fit="contain"
                                radius="8"
                                @click.stop="lookImg(data.imgList,imgindex)"
                                :src="imgsrc"
                            >
                                <template slot="loading">
                                    <van-loading type="spinner" size="20" />
                                </template>
                            </van-image>
                        </div>
                    <div class="official_reply"  v-for="(replyContent,replyContentindex) in data.replyContentList">
                        <div class="official_reply_head">
                            <img :src="head" alt="">
                        </div>
                        <div class="official_reply_view">
                            {{replyContent}}
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="nodata">
                    <img :src="nodataImg" alt="">
                    <div class="textcolor">{{language.no_records_available_at_the_moment}}</div>
                </div>
            </template>
        </div>
        <van-image-preview v-model="showImg" :images="imagesList">
        </van-image-preview>
    </div>
  </template>
  <script>
    import { post, get } from "../../../utils/api";
    import { getLangue } from "@/utils/language.js"
    import  failed_load  from "../404/index.vue"
    export default {
        props: {
            details:{}
        },
        components: {
            failed_load
        },
        computed: {
            failsbtn(){
                return this.$store.state.failsbtn; // 获取状态
            }
        },
        data() {
            return {
                language: getLangue(),
                imagesList:[],
                showImg:false,
                data:{},
                hasData:true,
                head:require('../../../static/img/head.jpg')
            };
        },
        created(){
            // var data = this.$route.params.details
            this.data = this.details;
        },
        methods: {
            lookImg(e,i){
                this.showImg = true;
                this.imagesList = e;
                this.startPosition = i
            },
            onClickLeft(){
                // this.$router.back()
                this.$emit('closeDetails')
            },
        },
    };
  </script>
  <style lang="scss" scoped>
  .app_view{
    height: 100vh;
    overflow: hidden;
    position: fixed;
    top:0;
    width: 100vw;
    background: #fff;
    z-index: 8;
  }
  .content{
    padding:12px 16px;
    height: calc(100vh - 70px);
    overflow-y: auto;
    position: relative;
  }
  .record_view{
    border-radius: 20px;
    background-color: rgba(0, 0, 0, 0.05);
    padding:14px;
    margin-bottom:20px;
    .record_time{
        display: flex;
        justify-content: space-between;
        margin-bottom:10px;
        .replied{
            color: rgba(71, 175, 62, 1);
        }
        .Awaiting_reply{
            color:rgba(238, 29, 29, 1);
        }
    }
    .record_text{
        color:rgba(119, 119, 119, 1);
        width:100%; 
        margin-bottom:14px;
    }
    .record_img{
        display: flex;
        min-height: 100px;
        margin-top:14px;
        align-items: center;
        div{
            margin-right: 2%;
            &:nth-of-type(3){
                margin-right: 0;
            }
        }
    }
  }
  .official_reply{
    display: flex;
    margin-top:18px;
    .official_reply_head{
        height: 34px;
        width: 34px;
        background-color: #ccc;
        border-radius: 8px;
        margin-right: 10px;
        overflow: hidden;
        img{
            height: 100%;
            width: 100%;
        }
    }
    .official_reply_view{
        padding:12px 16px;
        background-color: #fff;
        border-radius: 8px;
        flex:1;
    }
  }
  .nodata{
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    img{
        width: 260px;
    }
    div{
        font-size: 18px;
        text-align: center;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/view/feedbackDetails/index.vue